import { sendGoogleEvent, parameters } from '@html/_common/utils';

export default function SerpToursHighlightTags() {
  const SELECTOR_HIGHLIGHT_TAG = '.ao-serp-tag';
  const SELECTOR_JS_TOUR_CARD = '.js-ao-serp-tour, .list>ul>li.tour';
  const SELECTOR_JS_TOUR_NAME = '.js-ao-serp-tour__name';
  const SELECTOR_JS_IMAGE_LINK = '.js-ao-serp-tour__link';
  const GA_CATEGORY = `SERP Meaningful Tags - ${parameters.show_tours_highlights ? 'Showing' : 'Hidden'}`;

  this.initiate = () => {
    if (!parameters.use_tours_highlights) {
      return;
    }
    this.trackLoad();
    this.initTooltipTracking();
    this.initTourClickTracking();
  };

  this.trackOnTooltip = (text) => {
    sendGoogleEvent(
      GA_CATEGORY,
      'Show tag tooltip',
      text,
      { nonInteraction: false },
    );
  };

  this.initTooltipTracking = () => {
    let hoverTimer;
    let isHovered;
    let hoverOutTimer;
    const TOOLTIP_SHOW_DELAY = 700;
    const TOOLTIP_HIDE_DELAY = 400;

    $('.list').on('click', SELECTOR_HIGHLIGHT_TAG, (event) => {
      // prevent duplicate tracking for hover then click
      if (isHovered) {
        return;
      }

      const $element = $(event.currentTarget);
      this.trackOnTooltip($element.text());
    });

    $('.list').on('mouseover', SELECTOR_HIGHLIGHT_TAG, (event) => {
      isHovered = true;
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }

      // only fire tracking events if user hovers on tag long enough to see the tooltip
      hoverTimer = setTimeout(() => {
        if (!isHovered || hoverOutTimer) {
          return;
        }

        const $element = $(event.currentTarget);
        this.trackOnTooltip($element.text());
      }, TOOLTIP_SHOW_DELAY);
    });

    $('.list').on('mouseout', SELECTOR_HIGHLIGHT_TAG, () => {
      isHovered = false;
      hoverOutTimer = setTimeout(() => {
        clearTimeout(hoverOutTimer);
        hoverOutTimer = null;
      }, TOOLTIP_SHOW_DELAY + TOOLTIP_HIDE_DELAY);
    });
  };

  this.initTourClickTracking = () => {
    $('.list').on(
      'click',
      `.tourLink, .js-br__button-wrapper-view-cta, .bm a h4, .js-ao-serp-tour__view-tour, ${SELECTOR_JS_IMAGE_LINK}, ${SELECTOR_JS_TOUR_NAME}`,
      (event) => {
        const $target = $(event.target);
        if ($target.hasClass('js-ao-serp-tour__wishlist')) {
          return;
        }
        const $tourBlock = $target.closest(SELECTOR_JS_TOUR_CARD);
        const tag = $tourBlock.data('highlight-tag');

        sendGoogleEvent(
          GA_CATEGORY,
          `Click tour with${tag ? '' : 'out'} tag`,
          tag,
          { nonInteraction: false },
        );
      },
    );
  };

  this.trackLoad = () => {
    const $tours = $('.js-ao-serp-tour, .list>ul>li.tour');
    let tagCount = 0;
    const tagCountObj = {};
    $tours.each((index, tour) => {
      const tagType = $(tour).data('highlight-tag');
      if (!tagType) {
        return true;
      }
      if (tagCountObj[tagType]) {
        tagCountObj[tagType] += 1;
      } else {
        tagCountObj[tagType] = 1;
      }
      tagCount += 1;
      return true;
    });

    const tags = Object.keys(tagCountObj).map((tag) => `${tag}: ${tagCountObj[tag]}`);

    sendGoogleEvent(
      GA_CATEGORY,
      `${tagCount} / ${$tours.length}`,
      tags.join(','),
      { nonInteraction: true },
    );
  };
}
